

export type TypeAppIcon = 'close'
  | 'arrow--right'
  | 'arrow-select'
  | 'arrow-select--white'
  | 'pasta-left'
  | 'pasta-right'
  | 'arrow-left'
  | 'chevron'
  | 'cart-controls-box'
  | 'cart-controls-box--hm'
  | 'cart-controls-box--frozen'
  | 'plus'
  | 'bin--darkred'
  | 'double-quotes'

export const getIcon = (iconName: TypeAppIcon) => ({
  type: 'svg' as const,
  src: `/images/svg/i--${iconName}.svg`,
  alt: iconName + ' icon',
  size: { width: 24, height: 24 },
  content_type: 'image/svg+xml' as const
})
